import { filter } from 'lodash';

export const filterAppointmentsFor = (type, datetime, appointments) => {
  if (type === 'Month') {
    const onlyDate = datetime.substring(0, 10);
    return filter(appointments, (a) => a.availabilityFrom.includes(onlyDate));
  }
  const timeFrameStart = new Date(datetime.replace(/-/g, '/')).getTime();
  const timeFrameEnd = timeFrameStart + (29 * 60000);

  return filter(appointments, (a) => {
    const appointmentTime = new Date(a.availabilityFrom.replace(/-/g, '/')).getTime();
    return appointmentTime >= timeFrameStart && appointmentTime <= timeFrameEnd;
  }).sort((a, b) => new Date(a.availabilityFrom) - new Date(b.availabilityFrom));
};